import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'bangladesh_does_fac_comply_legal_req_ensure_against'

export const dataPointDefinition = {
  retracedId: 'bangladesh_does_fac_comply_legal_req_ensure_against',
  name: 'Bangladesh: Does the facility comply with legal requirements to ensure against overcrowding?',
  description:
    'This question is specific to Bangladesh only. Please consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'hs-gen-13',
      number: 'HS-GEN-14',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],fp-bi-7,Bangladesh',
      machineShowHide: '[1],fp-bi-7,15',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no',
      name: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31210,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
